<template>
  <div id="app">
    <Header />
    <signature-maker />
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import SignatureMaker from './components/SignatureMaker.vue'
export default {
  name: 'App',
  components: {
    Header,
    Footer,
    SignatureMaker
}
}
</script>

<!-- Louis's test theme  -->
<style theme="louis" lang="scss">
  @import './themes/louis/styles/_mystyle';
</style>


